/**
 * @generated SignedSource<<39a5d4c24e54eaccdff8b4b0a9b0dac5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PersonRequestDeleteMutation$variables = {
  id: number;
};
export type PersonRequestDeleteMutation$data = {
  readonly deletePersonRequest: {
    readonly id: number;
    readonly person: {
      readonly id: number;
      readonly person_requests: ReadonlyArray<{
        readonly id: number;
      }>;
    } | null | undefined;
  };
};
export type PersonRequestDeleteMutation = {
  response: PersonRequestDeleteMutation$data;
  variables: PersonRequestDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DeletePersonRequest",
    "kind": "LinkedField",
    "name": "deletePersonRequest",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "people",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "person_requests",
            "kind": "LinkedField",
            "name": "person_requests",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PersonRequestDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PersonRequestDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "6f651ce0b8dbc7d25261addef7a5a8ec",
    "id": null,
    "metadata": {},
    "name": "PersonRequestDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PersonRequestDeleteMutation(\n  $id: Int!\n) {\n  deletePersonRequest(id: $id) {\n    id\n    person {\n      id\n      person_requests {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "496fab7037477bfe8ac674f4dacf60cc";

export default node;
